import { TaxTableEntityType } from '@reliance/types/enums/TaxTableEntityType';
import { TaxTable } from '@reliance/types/models/Tax';
import { formatCurrency } from './Currency';

/**
 * Formats a tax table rate based on its entity type.
 * FSSF rates are displayed as per-minute (e.g., "$0.02/min").
 * All other rates are displayed as percentages (e.g., "5.00%").
 */
export function formatTaxTableRate(taxTable: TaxTable | null | undefined): string {
  if (taxTable == null) {
    return '';
  }

  const rate = parseFloat(String(taxTable.rate));
  if (rate == null || isNaN(rate) || typeof rate !== 'number') {
    return '';
  }

  if (taxTable.entityType === TaxTableEntityType.FSSF) {
    return `${formatCurrency(rate)}/min`;
  }

  return `${(rate * 100).toFixed(5)}%`;
}
